// API Service
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import auth from '../utils/auth';
import api from '../config/api';

const axiosInstance: AxiosInstance = axios.create({
  baseURL: api.base,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = auth.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // If FormData is being sent, remove Content-Type header to let axios set it with boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isLoginRequest =
        error.config?.url?.includes('auth/login') ||
        error.config?.url?.includes('/login');
      if (!isLoginRequest) {
        auth.removeToken();
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;

